/*
  cstrap-size.js — O SIZE TU GO (Lug & Buckle / Long & Short) DUNG CHUNG cho form V1 (custom-strap-form) va V2
  (custom-strap-form-v2). 08/10/2026 (chu shop): mot kieu duy nhat toan web, hai engine GOI CUNG ham — khong chep tay.

  Markup (Liquid, giong het hai form):
    #ccustom-lug-<SID> > .cfield > label[ ... <span data-size-gt> ] + p.cdesc + .cgrid2--pair > label.cnum x2
      label.cnum = <span.cnum__t>Lug</span><input #cf-lugcustom-SID><span.cnum__mm>mm</span>  (Buckle: #cf-bkwcustom-SID)
    #ccustom-len-<SID> — tuong tu, #cf-lencustom-SID (Long) / #cf-lenshort-SID (Short)
  Gia tri select van "Custom size (enter below)" (gio / engine / may tinh size doc gia tri). Chu hien = "Custom size" (20:29).

  API: CSTRAP_SIZE.gan(root, SID, syncHint) · CSTRAP_SIZE.giaTri(SID, 'lug'|'len') · CSTRAP_SIZE.kiem(SID, missing)
  Luat: lug 10–30, buckle 8–30, buckle <= lug · long / short so nguyen 50–200, long >= short.
  Chi khi HOP LE moi tra so: tieu de "…: 22 / 20 mm", chu cua lua chon trong menu "22 / 20 mm (custom)".
  Loi bao duoi o khi khach roi o (change) va khi bam them gio (engine goi kiem()). Thieu o -> chan them gio (engine).
  Co o = do DUNG select cua menu phia tren (cao / vien / bo goc / nen / dem); chu so >= 16px mobile, >= 15px PC.
*/
(function () {
  if (window.CSTRAP_SIZE) return;
  var CHU = 'Custom size';   /* 08/10 20:29 (chu shop) */
  /* 14/10: khoa bam (data-khoa-bam tren #cstrap-<SID>) goi o thu hai la BUCKLE, khong phai clasp (chu shop). Tank / khac giu 'clasp'. */
  function tuKhoa(s) { return document.querySelector('[data-khoa-bam]') ? String(s).replace(/clasp/g, 'buckle').replace(/Clasp/g, 'Buckle') : s; }
  var LOI = {
    lugTrong: 'Enter lug width (mm)',
    lugKhoang: 'Lug end must be 10–30 mm',
    bkTrong: 'Enter the buckle end width in mm',
    bkKhoang: 'Buckle end must be 8–30 mm',
    bkRong: 'The buckle end is usually narrower than the lug end (e.g. 22 / 20). Check you haven’t swapped them',
    bkTrongDep: 'Enter clasp width (mm)',
    bkKhoangDep: 'Clasp width must be 8–30 mm',
    bkRongDep: 'The clasp end is usually narrower than the lug end (e.g. 20 / 16)',
    dTrong: 'Enter the long end in mm',
    nTrong: 'Enter the short end in mm',
    lenKhoang: 'Enter a whole number from 50 to 200 mm',
    lenNguoc: 'The long end is usually longer than the short end. Check you haven’t swapped them'
  };

  function o(id, SID) { var x = document.getElementById(id + SID); return x && !x.disabled && !x.closest('[hidden]') ? x : null; }
  function soTho(x) { return String(x.value).trim().replace(',', '.').replace(/\s*mm$/i, ''); }
  function soLe(x) { var v = soTho(x); return /^\d{1,3}(\.\d)?$/.test(v) ? parseFloat(v) : NaN; }
  function soNguyen(x) { var v = soTho(x); return /^\d{1,3}$/.test(v) ? parseInt(v, 10) : NaN; }

  /* Danh sach loi cua tung khoi: [{ x: input, msg, nut }] — rong = hop le (hoac khoi dang an). */
  function loiLug(SID, ca) {
    var lug = o('cf-lugcustom-', SID), bk = o('cf-bkwcustom-', SID), r = [];
    if (bk && !bk.closest('[id^="ccustom-lug-"]')) bk = null;   /* 10/10: day khoa gap — o Clasp o hop rieng (loiBkw) */
    if (!lug) return r;
    var l = soLe(lug), k = bk ? soLe(bk) : NaN;
    if (!lug.value.trim()) { if (ca) r.push({ x: lug, msg: LOI.lugTrong, nut: 'Enter lug width' }); }
    else if (!(l >= 10 && l <= 30)) r.push({ x: lug, msg: LOI.lugKhoang, nut: 'Fix lug width' });
    else if (l < 16 && document.querySelector('select[name="properties[Buckle Width]"]')) r.push({ x: lug, msg: 'Lug width must be at least 16 mm for a deployant clasp'.replace('a deployant clasp', document.querySelector('[data-khoa-bam]') ? 'this strap' : 'a deployant clasp'), nut: 'Fix lug width' });   /* 10/10 17:20: khoa gap nho nhat 16 */
    if (bk) {
      if (!bk.value.trim()) { if (ca) r.push({ x: bk, msg: LOI.bkTrong, nut: 'Enter buckle width' }); }
      else if (!(k >= 8 && k <= 30)) r.push({ x: bk, msg: LOI.bkKhoang, nut: 'Fix buckle width' });
      else if (l >= 10 && l <= 30 && k > l) r.push({ x: bk, msg: LOI.bkRong, nut: 'Fix buckle width' });
    }
    return r;
  }
  /* 10/10 16:45 day khoa gap: hop Custom Clasp RIENG (#ccustom-bkw-) — kiem 8–30 KE CA khi Lug khong custom; Clasp > Lug -> bao. */
  function lugSo(SID) {
    var c = o('cf-lugcustom-', SID); if (c) return soLe(c);
    var s = document.getElementById('cf-' + SID + '-lug-width'); var m = s && /^(\d+(?:\.\d+)?)\s*mm$/i.exec(String(s.value || '').trim());
    return m ? parseFloat(m[1]) : NaN;
  }
  function loiBkw(SID, ca) {
    var bk = o('cf-bkwcustom-', SID), r = [];
    if (!bk || !bk.closest('[id^="ccustom-bkw-"]')) return r;
    var k = soLe(bk), l = lugSo(SID);
    if (!bk.value.trim()) { if (ca) r.push({ x: bk, msg: tuKhoa(LOI.bkTrongDep), nut: tuKhoa('Enter clasp width') }); }
    else if (!(k >= 8 && k <= 30)) r.push({ x: bk, msg: tuKhoa(LOI.bkKhoangDep), nut: tuKhoa('Fix clasp width') });
    else if (l > 0 && k > l) r.push({ x: bk, msg: tuKhoa(LOI.bkRongDep), nut: tuKhoa('Fix clasp width') });
    return r;
  }
  function loiLen(SID, ca) {
    var d = o('cf-lencustom-', SID), n = o('cf-lenshort-', SID), r = [];
    if (!d || !n) return r;
    var a = soNguyen(d), b = soNguyen(n);
    var okA = a >= 50 && a <= 200, okB = b >= 50 && b <= 200;
    var hn = !!(d.closest && d.closest('[data-hai-nua]'));   /* 10/10: day khoa gap — 2 nua bang nhau (Side 1 / Side 2), khong co luat dai >= ngan */
    if (!d.value.trim()) { if (ca) r.push({ x: d, msg: hn ? 'Enter side 1 in mm' : LOI.dTrong, nut: 'Enter length' }); }
    else if (!okA) r.push({ x: d, msg: LOI.lenKhoang, nut: 'Fix length' });
    if (!n.value.trim()) { if (ca) r.push({ x: n, msg: hn ? 'Enter side 2 in mm' : LOI.nTrong, nut: 'Enter length' }); }
    else if (!okB) r.push({ x: n, msg: LOI.lenKhoang, nut: 'Fix length' });
    if (!hn && okA && okB && a < b) r.push({ x: d, msg: LOI.lenNguoc, nut: 'Fix length' });
    return r;
  }

  function giaTri(SID, loai) {
    if (loai === 'bkw') {
      var b1 = o('cf-bkwcustom-', SID);
      if (!b1 || !b1.value.trim() || loiBkw(SID, true).length) return '';
      return soLe(b1) + ' mm';
    }
    if (loai === 'lug' && document.getElementById('ccustom-bkw-' + SID)) {   /* 10/10: day khoa gap — Lug la so DON "22 mm" (khong "22 / 22 mm") */
      var l1 = o('cf-lugcustom-', SID);
      if (!l1 || !l1.value.trim() || loiLug(SID, true).length) return '';
      return soLe(l1) + ' mm';
    }
    if (loai === 'lug') {
      var lug = o('cf-lugcustom-', SID), bk = o('cf-bkwcustom-', SID);
      if (!lug || !bk || !lug.value.trim() || !bk.value.trim() || loiLug(SID, true).length) return '';
      return soLe(lug) + ' / ' + soLe(bk) + ' mm';
    }
    var d = o('cf-lencustom-', SID), n = o('cf-lenshort-', SID);
    if (!d || !n || !d.value.trim() || !n.value.trim() || loiLen(SID, true).length) return '';
    if (d.closest && d.closest('[data-ngan-dai]')) return soNguyen(n) + ' / ' + soNguyen(d) + ' mm';   /* 14/10 khoa bam: SHORT / LONG */
    return soNguyen(d) + ' / ' + soNguyen(n) + ' mm';
  }

  /* Engine goi trong findMissing(): them loi vao danh sach chan them gio (bo qua o da co trong danh sach). */
  function kiem(SID, missing, chamCuoi) {   /* chamCuoi: engine KHONG tu them dau cham (V2) */
    danhDauSai(document.getElementById('ccustom-lug-' + SID), loiLug(SID, true));
    danhDauSai(document.getElementById('ccustom-len-' + SID), loiLen(SID, true));
    danhDauSai(document.getElementById('ccustom-bkw-' + SID), loiBkw(SID, true));
    loiLug(SID, true).concat(loiBkw(SID, true), loiLen(SID, true)).forEach(function (e) {
      var f = e.x.closest('.cfield') || e.x;
      if (missing.some(function (m) { return m.field === f; })) return;
      missing.push({ field: f, focus: e.x, label: /len/.test(e.x.id) ? 'Length' : (/bkw/.test(e.x.id) && e.x.closest('[id^="ccustom-bkw-"]') ? tuKhoa('Clasp Width') : 'Lug Width'), msg: chamCuoi ? e.msg + '.' : e.msg, nut: e.nut });
    });
  }

  /* 08/10 20:47 (chu shop): vien do CHI o o sai (khong to ca hang) — .cnum.is-sai, tinh lai moi lan bao loi. */
  function danhDauSai(box, ds) {
    if (!box) return;
    box.querySelectorAll('.cnum').forEach(function (n) { n.classList.remove('is-sai'); });
    /* 21:20: chi o DA GO so sai moi do ngay; o TRONG chi do khi engine bao loi ca khoi (bam them gio) — CSS :placeholder-shown */
    ds.forEach(function (e) { var n = e.x && e.x.closest && e.x.closest('.cnum'); if (n && e.x.value && e.x.value.trim()) n.classList.add('is-sai'); });
  }

  /* Loi tai cho khi khach roi o: chi loi SO SAI (khong bao "thieu" khi khach chua go xong). */
  function hopCua(SID, loai) { return document.getElementById((loai === 'lug' ? 'ccustom-lug-' : loai === 'bkw' ? 'ccustom-bkw-' : 'ccustom-len-') + SID); }
  function veLoi(SID, loai) {
    var box = hopCua(SID, loai);
    var f = box && box.querySelector('.cfield');
    if (!f) return;
    var ds = loai === 'lug' ? loiLug(SID, false) : loai === 'bkw' ? loiBkw(SID, false) : loiLen(SID, false);
    danhDauSai(box, ds);
    var el = f.querySelector('.cfield__err');
    if (ds.length) {
      if (!el) { el = document.createElement('p'); el.className = 'cfield__err'; f.appendChild(el); }
      el.textContent = ds[0].msg + '.';
      el.hidden = false;
      f.classList.add('has-error');
    } else if (f.classList.contains('has-error')) {
      /* het so sai -> go bao loi; o con THIEU thi engine bao lai luc khach bam them gio */
      f.classList.remove('has-error');
      if (el) el.textContent = '';
    }
  }

  function ve(SID, loai, syncHint) {
    var gt = giaTri(SID, loai);
    var box = hopCua(SID, loai);
    var tg = box && box.querySelector('[data-size-gt]');
    if (tg) tg.textContent = gt ? ': ' + gt : '';
    var sel = document.getElementById('cf-' + SID + (loai === 'lug' ? '-lug-width' : loai === 'bkw' ? '-buckle-width' : '-length'));
    if (!sel) return;
    var op = [].filter.call(sel.options, function (x) { return /^custom size/i.test(x.value); })[0];
    if (op && op.dataset.goc === undefined) op.dataset.goc = op.textContent.replace(/\s+/g, ' ').trim();   /* 08/10 16:05: chu goc cua muc Custom (Length / Lug khac nhau) */
    var chu = gt ? gt + ' (custom)' : ((op && op.dataset.goc) || CHU);
    if (op && op.textContent !== chu) { op.textContent = chu; if (op.dataset) op.dataset.clenNgan = chu; }
    if (typeof syncHint === 'function') syncHint(sel.closest('.cfield'));
  }

  /* Co o = co select cua menu phia tren (do that, ca mobile lan PC — khong mot con so chung cho hai man). */
  function doCo(SID, loai) {
    var sel = document.getElementById('cf-' + SID + (loai === 'lug' ? '-lug-width' : '-length'));
    var box = document.getElementById((loai === 'lug' ? 'ccustom-lug-' : 'ccustom-len-') + SID);
    if (!sel || !box || box.hidden || !sel.getClientRects().length) return;
    var c = getComputedStyle(sel), h = sel.getBoundingClientRect().height;
    var mb = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    var co = Math.max(parseFloat(c.fontSize) || 0, mb ? 16 : 15);
    box.querySelectorAll('.cnum').forEach(function (n) {
      /* ghi BIEN CSS (khong ghi thang thuoc tinh) -> vien focus / vien loi trong cstrap-size.css van doi duoc */
      var st = n.style;
      st.setProperty('--cnum-h', Math.round(h) + 'px');
      st.setProperty('--cnum-bw', c.borderTopWidth); st.setProperty('--cnum-bs', c.borderTopStyle); st.setProperty('--cnum-bc', c.borderTopColor);
      st.setProperty('--cnum-br', c.borderTopLeftRadius); st.setProperty('--cnum-bg', c.backgroundColor);
      st.setProperty('--cnum-pl', c.paddingLeft); st.setProperty('--cnum-fs', co + 'px'); st.setProperty('--cnum-ff', c.fontFamily); st.setProperty('--cnum-c', c.color);
    });
  }

  /* 08/10 18:58 (chu shop): MOI o so tu go (.cnum: Lug, Buckle, Long, Short, W/D/K) + o co tay trong popup — chi nhan so + MOT dau
     cham / phay (phay -> cham), toi da 4 ky tu, phan nguyen toi da 2 chu so (Long / Short: 3 — "135"), 1 so le. "58888" -> "58".
     inputmode decimal. Luat khoang (Lug / Buckle 10–30…) va bao loi giu nguyen o kiem(). */
  function locSo(x, nguyen) {
    var v0 = x.value, v = v0.replace(/,/g, '.').replace(/[^0-9.]/g, '');
    var i = v.indexOf('.');
    var a = i > -1 ? v.slice(0, i) : v, b = i > -1 ? v.slice(i + 1).replace(/\./g, '') : null;
    a = a.slice(0, nguyen);
    v = b === null ? a : a + '.' + b.slice(0, 1);
    v = v.slice(0, 4);
    if (v !== v0) x.value = v;
  }
  function soNguyenToiDa(x) { return /^cf-(lencustom|lenshort)-/.test(x.id || '') ? 3 : 2; }
  function ganLocSo(root) {
    if (!root || root.__locSo) return;
    root.__locSo = 1;
    root.querySelectorAll('.cnum input').forEach(function (x) { x.setAttribute('inputmode', 'decimal'); x.setAttribute('maxlength', '4'); x.removeAttribute('pattern'); x.setAttribute('placeholder', ' '); });   /* placeholder 1 dau cach (khong thay) -> CSS nhan o trong */
    root.addEventListener('input', function (e) { var x = e.target; if (x && x.closest && x.closest('.cnum')) locSo(x, soNguyenToiDa(x)); }, true);
  }

  function gan(root, SID, syncHint) {
    if (!root || root.__csizeGan) return;
    root.__csizeGan = 1;
    ganLocSo(root);
    function ca(loai) { ve(SID, loai, syncHint); }
    ['input', 'change'].forEach(function (ev) {
      root.addEventListener(ev, function (e) {
        var id = (e.target && e.target.id) || '';
        var bkRieng = /^cf-bkwcustom-/.test(id) && e.target.closest && e.target.closest('[id^="ccustom-bkw-"]');   /* 10/10 day khoa gap */
        var lug = /^cf-(lugcustom|bkwcustom)-/.test(id) && !bkRieng, len = /^cf-(lencustom|lenshort)-/.test(id);
        if (bkRieng || /-buckle-width$/.test(id)) { ca('bkw'); if (ev === 'change' && bkRieng) veLoi(SID, 'bkw'); }
        if (/^cf-lugcustom-/.test(id) || /-lug-width$/.test(id)) { if (document.getElementById('ccustom-bkw-' + SID)) ca('bkw'); }
        if (lug || /-lug-width$/.test(id)) { ca('lug'); if (ev === 'change' && lug) veLoi(SID, 'lug'); }
        if (len || /-length$/.test(id)) { ca('len'); if (ev === 'change' && len) veLoi(SID, 'len'); }
        if (ev === 'change' && /-(lug-width|length)$/.test(id)) setTimeout(function () { doCo(SID, 'lug'); doCo(SID, 'len'); }, 0);
      });
    });
    var hen = null;
    window.addEventListener('resize', function () { clearTimeout(hen); hen = setTimeout(function () { doCo(SID, 'lug'); doCo(SID, 'len'); }, 150); });
    ca('lug'); ca('len'); doCo(SID, 'lug'); doCo(SID, 'len');
  }

  /* ===================== 08/10 (chu shop, muc 7) — O SO DO KIEU CAT: MIDDLE CUT (W / D) · WING CUT (W / D / K) =====================
     Khoi #ccut-<SID> (23:25: DUOI Lug Width; duoi luoi Style chi con dong nhac #ccut-duoi-<SID>). Chon Middle Cut / Wing Cut -> hien khoi, bat o (khong thi an + disable — khong vao gio).
     Theo ban ve: Middle Cut W = be rong o khoet giua, D = do sau. Wing Cut W = luoi giua, D = do sau phan khoet hai ben,
     K = be rong phan khoet MOI BEN (ban ve: bac thap o hai goc) — W + 2K = lug width.
     Tick "Not sure — I'll upload a photo" -> W/D/K khong bat buoc, anh dong ho BAT BUOC (mo san khoi upload cua form). */
  var CAT = {
    middle: { ten: 'Middle Cut size', sub: ' (mm)', hd: 'W = width of the cut-out. D = how deep it goes.', o: ['w', 'd'] },   /* 20:47 */
    wing: { ten: 'Wing Cut size', sub: ' (mm)', hd: 'W = centre tongue. D = depth of side cuts. K = each side cut.', o: ['w', 'd', 'k'] }
  };
  function kieuCat(SID) {
    var r = document.querySelector('#cstrap-' + SID + ' input[name="properties[Style of Strap]"]:checked') || document.querySelector('input[name="properties[Style of Strap]"]:checked');
    var v = r ? r.value : '';
    return /middle cut/i.test(v) ? 'middle' : /wing cut/i.test(v) ? 'wing' : '';
  }
  function oCat(SID, k) { return document.getElementById('cf-cut' + k + '-' + SID); }
  function lugDangChon(SID) {
    var s = document.getElementById('cf-' + SID + '-lug-width');
    if (s && /^custom/i.test(s.value)) { var c = document.getElementById('cf-lugcustom-' + SID); return c ? soLe(c) : NaN; }
    return s ? parseFloat(s.value) : NaN;
  }
  function anhDaTai(SID) {
    var n = 0;
    document.querySelectorAll('#cstrap-' + SID + ' input[type="file"][name^="properties[Watch Photo"]').forEach(function (i) { n += i.files ? i.files.length : 0; });
    return n;
  }
  function loiCat(SID, ca) {
    var k = kieuCat(SID), r = [];
    var box = document.getElementById('ccut-' + SID);
    if (!k || !box || box.hidden) return r;
    var tick = document.getElementById('cf-cutanh-' + SID);
    if (tick && tick.checked) {
      if (ca && !anhDaTai(SID)) r.push({ x: tick, msg: 'Upload a photo of your watch so we can measure the cut', nut: 'Upload a photo' });
      return r;
    }
    var lug = lugDangChon(SID), so = {}, KH = k === 'middle' ? { w: [2, 20], d: [1, 10] } : { w: [8, 30], d: [1, 10], k: [1, 6] };
    CAT[k].o.forEach(function (t) {
      var x = oCat(SID, t); if (!x) return;
      var v = soLe(x); so[t] = v;
      if (!x.value.trim()) { if (ca) r.push({ x: x, msg: 'Enter ' + t.toUpperCase() + ' in mm', nut: 'Enter cut size' }); return; }
      if (!(v >= KH[t][0] && v <= KH[t][1])) r.push({ x: x, msg: t.toUpperCase() + ' must be ' + KH[t][0] + '–' + KH[t][1] + ' mm', nut: 'Fix cut size' });
    });
    if (!r.length && so.w >= 0 && lug > 0 && !(so.w < lug)) r.push({ x: oCat(SID, 'w'), msg: 'W must be smaller than your lug width (' + lug + ' mm)', nut: 'Fix cut size' });
    if (!r.length && k === 'wing' && lug > 0 && so.w > 0 && so.k > 0 && Math.abs(so.w + 2 * so.k - lug) > 0.5)
      r.push({ x: oCat(SID, 'k'), msg: 'W + 2 × K should equal your lug width (e.g. 18 + 2 + 2 = 22). Please check', nut: 'Fix cut size' });
    return r;
  }
  function giaTriCat(SID) {
    var k = kieuCat(SID); if (!k) return '';
    var tick = document.getElementById('cf-cutanh-' + SID);
    if (tick && tick.checked) return '';
    var ds = CAT[k].o.map(function (t) { var x = oCat(SID, t); return x && x.value.trim() ? soLe(x) : NaN; });
    if (ds.some(function (v) { return !(v >= 0); }) || loiCat(SID, true).length) return '';
    return ds.join(' / ') + ' mm';
  }
  function veCat(SID) {
    var box = document.getElementById('ccut-' + SID); if (!box) return;
    var k = kieuCat(SID), co = !!k;
    box.hidden = !co;
    var duoi = document.getElementById('ccut-duoi-' + SID); if (duoi) duoi.hidden = !co;   /* 23:25: dong nhac duoi luoi Style — khoi o so nam duoi Lug Width */
    ['w', 'd', 'k'].forEach(function (t) { var x = oCat(SID, t); if (!x) return; var dung = co && CAT[k].o.indexOf(t) > -1; x.disabled = !dung; var l = x.closest('.cnum'); if (l) l.hidden = !dung; });
    var tick = document.getElementById('cf-cutanh-' + SID); if (tick) tick.disabled = !co;
    veLoiCat(SID);   /* het loi -> go cau bao cu (ke ca "Upload a photo" engine bao luc bam them gio) */
    /* 16/10 (chu shop): dang dau Middle Cut / Wing Cut KHONG lam duoc Curved -> chon Middle/Wing thi AN o Curved End
       (ca dropdown phu cua mto nam trong .cfield) va ep ve Straight ("No") de khong cong phi Curved; bo chon -> hien lai. */
    var ce = document.querySelector('#cstrap-' + SID + ' [data-curved-end]') || document.querySelector('form [data-curved-end]');
    if (ce) {
      var fce = ce.closest('.cfield') || ce;
      if (co) {
        var ceNo = [].slice.call(fce.querySelectorAll('input[type="radio"]')).filter(function (x) { return /^(no|none|straight)/i.test(x.value); })[0];
        if (ceNo && !ceNo.checked) (ceNo.closest('label') || ceNo).click();
      }
      fce.hidden = co;
    }
    if (!co) return;
    var c = CAT[k], gt = giaTriCat(SID);
    var ten = box.querySelector('[data-cut-ten]'), sub = box.querySelector('[data-cut-sub]'), g = box.querySelector('[data-cut-gt]'), hd = box.querySelector('[data-cut-hd]');
    if (ten) ten.textContent = c.ten; if (sub) sub.textContent = c.sub;   /* 20:47: "MIDDLE CUT SIZE (mm): 6 / 3 mm" */ if (g) g.textContent = gt ? ': ' + gt : ''; if (hd) hd.textContent = c.hd;
    var hang = box.querySelector('[data-cut-o]'); if (hang) hang.classList.toggle('is-ba', k === 'wing');
    var anh = box.querySelector('[data-cut-anh]');
    if (anh) {   /* 21:20: anh to = ban ve dau day cat san (data-ve-*), bam mo ban ve day du (data-src-*) */
      var src = anh.getAttribute('data-src-' + k), ve = anh.getAttribute('data-ve-' + k) || src, im = anh.querySelector('img');
      if (im && im.getAttribute('src') !== ve) { im.setAttribute('src', ve); im.setAttribute('alt', k === 'middle' ? 'Middle Cut — W and D on the strap end' : 'Wing Cut — W, D and K on the strap end');
        if (k === 'middle') { im.setAttribute('width', '410'); im.setAttribute('height', '175'); } else { im.setAttribute('width', '420'); im.setAttribute('height', '190'); } }   /* 23:25: SVG ve lai, dung viewBox */
      anh.setAttribute('data-help-img', src); anh.setAttribute('data-help-title', k === 'middle' ? 'Middle Cut' : 'Wing Cut');
    }
  }
  function ganCat(root, SID) {
    var box = document.getElementById('ccut-' + SID);
    if (!box || box.__catGan) return;
    box.__catGan = 1;
    ['input', 'change'].forEach(function (ev) {
      root.addEventListener(ev, function (e) {
        var t = e.target || {}, n = t.name || '', id = t.id || '';
        if (n === 'properties[Style of Strap]' || /^cf-cut/.test(id) || /-lug-width$|^cf-lugcustom-/.test(id) || /^properties\[Watch Photo/.test(n)) veCat(SID);
        if (ev === 'change' && /^cf-cut[wdk]-/.test(id)) veLoiCat(SID);
        if (ev === 'change' && id === 'cf-cutanh-' + SID && t.checked) {
          /* mo san khoi upload cua form (o "unsure") */
          var u = document.getElementById('cf-unsure-' + SID); if (u && !u.checked) u.click();
          /* 15/10 (chu shop: "tich roi khong co cho up a?"): o Watch Photo nam tan cuoi form -> keo len NGAY DUOI khoi Cut va cuon toi.
             Tren bai may san (cstrap-mto-v2) o nay da duoc coi la "ngoai" khi trang co #ccut-, nen MutationObserver khong keo lai. */
          var up = document.querySelector('#cstrap-' + SID + ' input[type="file"][name^="properties[Watch Photo"]');
          var fUp = up && up.closest('.cfield'), oW = oCat(SID, 'w'), fCat = oW && oW.closest('.cfield');
          if (fUp && fCat && fUp !== fCat && fUp.previousElementSibling !== fCat) fCat.parentNode.insertBefore(fUp, fCat.nextSibling);
          if (fUp) setTimeout(function () { try { fUp.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e2) {} }, 200);
        }
      });
    });
    veCat(SID);
  }
  function veLoiCat(SID) {
    var box = document.getElementById('ccut-' + SID), f = box && box.querySelector('.cfield'); if (!f) return;
    var ds = loiCat(SID, false), el = f.querySelector('.cfield__err');
    danhDauSai(box, ds);
    if (ds.length) { if (!el) { el = document.createElement('p'); el.className = 'cfield__err'; f.appendChild(el); } el.textContent = ds[0].msg + '.'; el.hidden = false; f.classList.add('has-error'); }
    else if (f.classList.contains('has-error')) { f.classList.remove('has-error'); if (el) el.textContent = ''; }
  }
  var kiemSize = kiem;
  kiem = function (SID, missing, chamCuoi) {
    kiemSize(SID, missing, chamCuoi);
    danhDauSai(document.getElementById('ccut-' + SID), loiCat(SID, true));
    loiCat(SID, true).forEach(function (e) {
      var f = e.x.closest('.cfield') || e.x;
      if (missing.some(function (m) { return m.field === f; })) return;
      missing.push({ field: f, focus: e.x, label: 'Cut size', msg: chamCuoi ? e.msg + '.' : e.msg, nut: e.nut });
    });
  };
  var ganSize = gan;
  gan = function (root, SID, syncHint) { ganSize(root, SID, syncHint); ganCat(root, SID); };

  /* ===================== 08/10 (chu shop 16:05 + 16:44) — "FIND YOUR SIZE" TRONG POPUP "?" LENGTH, DUNG CHUNG V1 + V2 =====================
     O co tay CHI nam trong popup (khong co o nao ngoai trang). Markup: snippets/cstrap-length-guide(-v2).liquid, tinh_size: true.
     16:44: SO KHOANG theo bang goc (strap-size-table, 2 cot "Long / Short" | "Your wrist"), KHONG lam tron: 16.3 -> 115/70; 16.6 -> 115/75;
     22.6 -> Custom size. Go -> "Suggested: 115/70 mm — wrist 15.6–16.5 cm", to nen dong do trong bang ngay duoi.
     Apply -> chon option Length THAT (ban change), dong popup, vien o Length nhay 1 lan. Custom size -> mo Long / Short, dien goi y:
     long = long hang cuoi bang (135), short = short hang cuoi (105) + 10 mm moi cm tren 22 (lam tron 5 mm). Khach sua duoc.
     properties[Wrist Size] CHI khi bam Apply: "16.3 cm" / "6.4 in (16.3 cm)"; doi size tay sau do -> "16.3 cm — chose 115/75 mm". */
  var CT_MOC = 22;   /* short goi y = short hang cuoi + 10 mm moi cm tren moc nay (chu shop) */
  function nhanOp(op) { return (op.dataset.goc || op.textContent || '').replace(/\s+/g, ' ').trim(); }
  function tinhSize(sec) {
    var hop = document.querySelector('[data-tinh-size]');
    if (!hop || hop.dataset.xong) return;
    var sel = sec && sec.querySelector('select[name="properties[Length]"]'), wr = sec && sec.querySelector('[data-wrist-size]');
    if (!sel) return;
    hop.dataset.xong = '1';
    var o = hop.querySelector('[data-tinh-o]'), kq = hop.querySelector('[data-tinh-kq]'), nut = hop.querySelector('[data-tinh-apply]');
    var SID = (sel.id || '').replace(/^cf-/, '').replace(/-length$/, '');
    var dv = 'cm', goiY = null, apDung = null;
    var HINT = 'Suggested fit. Big watch (44 mm+): size down. Prefer loose: size up.';
    /* bang goc: cot 1 = Long / Short ("115 / 70 mm" | "My own size"), cot 2 = co tay ("15.6 – 16.5 cm" | "over 22.5 cm") */
    function bang() {
      var ds = [];
      [].forEach.call(document.querySelectorAll('.sguide-panel[data-guide="length"] .ssize-table tbody tr'), function (tr) {
        var td = tr.querySelectorAll('td');
        if (td.length < 2) { if (td[0] && /custom/i.test(td[0].textContent)) ds.push({ tr: tr, max: Infinity, dai: NaN, ngan: NaN, mm: '' }); return; }   /* 20:29: dong cuoi gop 1 o "Custom size — …" */
        var mm = (td[0].textContent.match(/\d+/g) || []).map(Number), so = (td[1].textContent.match(/\d+(?:\.\d+)?/g) || []).map(parseFloat);
        if (!so.length) return;
        ds.push({ tr: tr, max: /over/i.test(td[1].textContent) ? Infinity : so[so.length - 1], dai: mm[0], ngan: mm[1], mm: mm.length >= 2 ? mm[0] + '/' + mm[1] + ' mm' : '' });
      });
      return ds;
    }
    function opCua(d) {
      for (var i = 0; i < sel.options.length; i++) {
        var x = sel.options[i]; if (!x.value || x.disabled) continue;
        if (d.mm ? x.value.indexOf(d.mm + ' — ') === 0 || x.value === d.mm : /^custom/i.test(x.value)) return x;
      }
      return null;
    }
    function bao(chu, kieu) { kq.textContent = chu; kq.classList.remove('is-loi', 'is-ok', 'is-hint'); kq.classList.add(kieu); }
    function tinh() {
      var ds = bang();
      ds.forEach(function (d) { d.tr.classList.remove('is-goiy'); });
      goiY = null; nut.disabled = true;
      var t = (o.value || '').replace(',', '.').trim(), n = parseFloat(t);
      if (!t || isNaN(n)) { bao(HINT, 'is-hint'); return; }
      var cm = Math.round((dv === 'in' ? n * 2.54 : n) * 10) / 10;   /* 1 so le nhu bang */
      if (cm < 12 || cm > 26) { bao('Check your measurement', 'is-loi'); return; }
      var d = null;
      for (var i = 0; i < ds.length && !d; i++) if (cm <= ds[i].max) d = ds[i];
      var op = d && opCua(d);
      if (!op) { bao(HINT, 'is-hint'); if (window.console) console.warn('cstrap-size: tinhSize — dong bang khong khop option Length', d && d.mm); return; }
      d.tr.classList.add('is-goiy');
      goiY = { cm: cm, nhap: n, dv: dv, op: op };
      bao('Suggested: ' + nhanOp(op), 'is-ok');
      nut.disabled = false;
    }
    function ghiWrist() {
      if (!wr) return;
      if (!apDung || !sel.value) { wr.value = ''; wr.disabled = true; return; }
      var v = apDung.chu, cur = sel.options[sel.selectedIndex];
      if (sel.value !== apDung.opVal && cur) v += ' — chose ' + (/^custom/i.test(cur.value) ? 'custom size' : cur.value.split(' — ')[0]);
      wr.value = v; wr.disabled = false;
    }
    function ban(x, ev) { x.dispatchEvent(new Event(ev, { bubbles: true })); }
    function dienDai(cm) {
      var d = document.getElementById('cf-lencustom-' + SID), m = document.getElementById('cf-lenshort-' + SID);
      var c = null; bang().forEach(function (r) { if (r.dai > 0 && r.ngan > 0) c = r; });
      if (!d || !m || !c) return;
      var ngan = Math.round((c.ngan + 10 * (cm - CT_MOC)) / 5) * 5, dai = c.dai;
      if (d.closest && d.closest('[data-hai-nua]')) { dai = ngan = Math.round((c.dai + 5 * (cm - CT_MOC)) / 5) * 5; }   /* 10/10 day khoa gap: 2 nua bang nhau */
      [[d, dai], [m, ngan]].forEach(function (p) {
        var x = p[0];
        if (x.value.trim() && x.dataset.ctDien !== x.value) return;   /* khach da tu go -> giu */
        x.value = String(p[1]); x.dataset.ctDien = x.value; ban(x, 'input'); ban(x, 'change');
      });
    }
    ['cf-lencustom-', 'cf-lenshort-'].forEach(function (k) {
      var x = document.getElementById(k + SID);
      if (x) x.addEventListener('input', function (e) { if (e.isTrusted) delete x.dataset.ctDien; });
    });
    o.setAttribute('maxlength', '4'); o.setAttribute('inputmode', 'decimal');
    o.addEventListener('input', function () {
      locSo(o, 2);   /* 18:58: cung luat o so tu go */
      tinh();
      if (!o.value.trim() && apDung) { apDung = null; ghiWrist(); }   /* xoa o co tay -> khong gui */
    });
    hop.querySelectorAll('[data-tinh-dv]').forEach(function (b) {
      b.addEventListener('click', function () {
        dv = b.getAttribute('data-tinh-dv');
        hop.querySelectorAll('[data-tinh-dv]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        o.placeholder = dv === 'in' ? 'e.g. 6.7' : 'e.g. 17.0';
        tinh();
      });
    });
    nut.addEventListener('click', function () {
      if (!goiY) return;
      var cmTxt = goiY.cm.toFixed(1) + ' cm';
      apDung = { chu: goiY.dv === 'in' ? (Math.round(goiY.nhap * 10) / 10).toFixed(1) + ' in (' + cmTxt + ')' : cmTxt, opVal: goiY.op.value };
      if (sel.value !== goiY.op.value) { sel.value = goiY.op.value; ban(sel, 'input'); ban(sel, 'change'); }
      ghiWrist();
      var laCustom = /^custom/i.test(goiY.op.value), cm = goiY.cm;
      var close = document.querySelector('.sguide-lb:not([hidden]) .sguide-lb__close');
      if (close) close.click();
      var f = sel.closest('.cfield');
      setTimeout(function () {
        if (laCustom) dienDai(cm);
        if (f) { f.scrollIntoView({ behavior: 'smooth', block: 'center' }); f.classList.remove('is-flash'); void f.offsetWidth; f.classList.add('is-flash'); setTimeout(function () { f.classList.remove('is-flash'); }, 1200); }
      }, 350);
    });
    sel.addEventListener('change', ghiWrist);   /* doi Length tay sau Apply -> " — chose 115/75 mm" */
    tinh();
  }

  var ganTruocTinh = gan;
  gan = function (root, SID, syncHint) { ganTruocTinh(root, SID, syncHint); tinhSize((root && root.closest && root.closest('.cstrap-section')) || root); };

  window.CSTRAP_SIZE = { CHU: CHU, giaTri: giaTri, kiem: kiem, gan: gan, doCo: doCo, giaTriCat: giaTriCat, tinhSize: tinhSize };
})();
